var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.name = require("./name");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/company/index.js
 ** module id = 267
 ** module chunks = 0
 **/